module.exports = __webpack_public_path__ + "static/media/sector-management.44b8cf07.svg";